import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  Btn,
  ConfirmDialog,
  CustomCalendar,
  CustomCheckbox,
  CustomPanel,
  InputText,
  PageHeader,
  SectionHeader,
  SectionTitle,
} from '../../../../components'
import { FaClipboardList, FaRegIdCard } from 'react-icons/fa'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import * as colors from '../../../../assets/js/colors'
import { ROTAS_CHECKLIST } from '../../../../constants/checklist-operacional'
import useEstruturaChecklist, { LOAD_MESSAGE } from './EstruturaChecklistHook'
import CamposChecklist from './CamposChecklist'
import CorpoChecklist from './CorpoChecklist'
import ModalPreviewChecklist from './ModalPreviewChecklist/ModalPreviewChecklist'
import {
  contarItens,
  formatarDataHoraExibicao,
  LIMITES,
  montarPayload,
} from '../shared/checklist.util'

const styles = {
  botoes: { textAlign: 'right' },
  botao: { marginLeft: 10 },
  identificacao: {
    marginTop: 15,
    padding: '12px 15px 8px 15px',
    backgroundColor: '#f2fafb',
    border: '1px solid #d3edf0',
    borderLeft: `4px solid ${colors.azul}`,
    borderRadius: 3,
  },
  identificacaoCabecalho: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 },
  identificacaoTitulo: {
    color: colors.azul,
    fontWeight: 'bold',
    fontSize: '0.85rem',
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  dica: { color: colors.gray, fontSize: '0.8rem' },
  estrutura: { marginTop: 30 },
  dicaEstrutura: { color: colors.gray, fontSize: '0.8rem', marginTop: 8 },
  ativo: { display: 'flex', alignItems: 'flex-end', paddingBottom: 15 },
  criacao: { color: colors.gray, fontSize: '0.8rem' },
  observacao: { display: 'flex', alignItems: 'flex-end', paddingBottom: 15 },
  rodape: { textAlign: 'right', marginTop: 25 },
}

function EstruturaChecklist({ selectedTp, dispatch, history }) {
  const { state, localDispatch } = useEstruturaChecklist()
  const tpInicial = useRef(selectedTp)
  const { checklist } = state

  useEffect(() => {
    if (!selectedTp || selectedTp !== tpInicial.current) {
      history.replace(ROTAS_CHECKLIST.CADASTRO)
      return
    }
    localDispatch.onInit(selectedTp, history.location.state)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.GET:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.getChecklist(selectedTp, state.origem)
        break
      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.save(selectedTp, state.checklist)
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.clearMessages()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage, null))
      localDispatch.clearMessages()
      history.replace(ROTAS_CHECKLIST.ESTRUTURA, { checklistId: state.checklist.id })
    }
  }, [state.successMessage])

  useEffect(() => {
    if (state.voltar) history.push(ROTAS_CHECKLIST.CADASTRO)
  }, [state.voltar])

  const botoes = (
    <div className="p-col-9" style={styles.botoes}>
      <Btn style={styles.botao} onClick={() => localDispatch.onTogglePreview(true)}>
        Pré-visualizar
      </Btn>
    </div>
  )

  return (
    <div>
      <PageHeader>10.1.1 - Estrutura do Checklist</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          btnLabel="Salvar"
          onNovo={localDispatch.onBtnSalvarClicked}
          onVoltar={localDispatch.onBtnVoltarClicked}
          childrenButtons={botoes}
        >
          <div style={styles.identificacao}>
            <div style={styles.identificacaoCabecalho}>
              <FaRegIdCard size={18} color={colors.azul} />
              <span style={styles.identificacaoTitulo}>Identificação do checklist</span>
            </div>
            <div className="p-grid">
              <div className="p-md-3 p-col-12">
                <InputText
                  label="Código:*"
                  marginTop={10}
                  maxLength={LIMITES.codigo}
                  value={checklist.checklist_code}
                  onChange={value => localDispatch.onIdentificacaoChange('checklist_code', value)}
                />
              </div>
              <div className="p-md-5 p-col-12">
                <InputText
                  label="Título:*"
                  marginTop={10}
                  maxLength={LIMITES.titulo}
                  value={checklist.title}
                  onChange={value => localDispatch.onIdentificacaoChange('title', value)}
                />
              </div>
              <div className="p-md-2 p-col-12">
                <CustomCalendar
                  label="Data de Revisão:"
                  value={checklist.reviewed_at}
                  showButtonBar
                  onChange={value => localDispatch.onIdentificacaoChange('reviewed_at', value)}
                />
              </div>
              <div className="p-md-2 p-col-12" style={styles.ativo}>
                <CustomCheckbox
                  checked={checklist.actived}
                  onChange={value => localDispatch.onIdentificacaoChange('actived', value)}
                >
                  Ativo
                </CustomCheckbox>
              </div>
              {checklist.created_at ? (
                <div className="p-col-12" style={styles.criacao}>
                  Criado em {formatarDataHoraExibicao(checklist.created_at)}
                </div>
              ) : null}
            </div>
          </div>

          <div style={styles.estrutura}>
            <SectionHeader
              icon={<FaClipboardList size={18} />}
              titleStyle={styles.identificacaoTitulo}
            >
              Estrutura do formulário
            </SectionHeader>
            <div style={styles.dicaEstrutura}>
              Cabeçalho, corpo, observações e rodapé que serão preenchidos na execução do checklist.
            </div>
          </div>

          <CamposChecklist
            titulo="Cabeçalho"
            secao="header"
            campos={checklist.header}
            focoId={state.focoId}
            localDispatch={localDispatch}
          />

          <CorpoChecklist
            etapas={checklist.body}
            totalItens={contarItens(checklist)}
            focoId={state.focoId}
            localDispatch={localDispatch}
          />

          <div style={{ marginTop: 10 }}>
            <SectionTitle title="Observações" />
            <div className="p-grid">
              <div className="p-md-4 p-col-12" style={styles.observacao}>
                <CustomCheckbox
                  checked={checklist.observations.enabled}
                  onChange={value =>
                    localDispatch.onObservacoesChange('observations', 'enabled', value)
                  }
                >
                  Campo de observações gerais
                </CustomCheckbox>
              </div>
              <div className="p-md-8 p-col-12">
                <InputText
                  label="Rótulo das observações gerais:"
                  marginTop={10}
                  maxLength={LIMITES.rotulo}
                  disabled={!checklist.observations.enabled}
                  value={checklist.observations.label}
                  onChange={value =>
                    localDispatch.onObservacoesChange('observations', 'label', value)
                  }
                />
              </div>
              <div className="p-md-4 p-col-12" style={styles.observacao}>
                <CustomCheckbox
                  checked={checklist.item_observations.enabled}
                  onChange={value =>
                    localDispatch.onObservacoesChange('item_observations', 'enabled', value)
                  }
                >
                  Permitir observação em cada item
                </CustomCheckbox>
              </div>
              <div className="p-md-8 p-col-12">
                <InputText
                  label="Rótulo da observação por item:"
                  marginTop={10}
                  maxLength={LIMITES.rotulo}
                  disabled={!checklist.item_observations.enabled}
                  value={checklist.item_observations.label}
                  onChange={value =>
                    localDispatch.onObservacoesChange('item_observations', 'label', value)
                  }
                />
              </div>
            </div>
          </div>

          <CamposChecklist
            titulo="Rodapé"
            secao="footer"
            campos={checklist.footer}
            focoId={state.focoId}
            localDispatch={localDispatch}
          />

          <div style={styles.rodape}>
            <Btn onClick={localDispatch.onBtnSalvarClicked}>Salvar</Btn>
          </div>
        </CustomPanel>
      </div>

      {state.showPreview ? (
        <ModalPreviewChecklist
          show={state.showPreview}
          payload={montarPayload(checklist)}
          onClose={() => localDispatch.onTogglePreview(false)}
        />
      ) : null}
      <ConfirmDialog
        isVisible={state.confirmVoltar}
        title="Atenção"
        content={<span>Existem alterações não salvas. Deseja sair sem salvar?</span>}
        okLabel="SAIR"
        onCancelar={() => localDispatch.onConfirmVoltar(false)}
        onOk={() => localDispatch.onConfirmVoltar(true)}
      />
      <ConfirmDialog
        isVisible={!!state.remocao}
        title="Atenção"
        content={<span>{state.remocao ? state.remocao.mensagem : ''}</span>}
        okLabel="REMOVER"
        onCancelar={localDispatch.onCancelarRemocao}
        onOk={localDispatch.onConfirmarRemocao}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(EstruturaChecklist))
